export default "__VITE_ASSET__00739ce2__"